import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import { filter } from 'rxjs';
import { MixpanelService } from '../../../../../../mixpanel/mixpanel.service';
import { Paths } from '../../../enums/paths.enum';
import { UsersNavigationService } from '../../../shared/services/users.navigation.service';
import { BasePageComponent } from '../../base.page';

const debug = Debug('aumico:aumico-project-reports:SsoCallbackPageComponent');

@UntilDestroy()
@Component({
    selector: 'app-auth-sso-callback',
    templateUrl: './sso-callback.page.html',
    styleUrls: ['./sso-callback.page.scss'],
})
export class SsoCallbackPageComponent extends BasePageComponent implements OnInit {
    constructor(
        injector: Injector,
        private usersNavigationService: UsersNavigationService,
        private readonly mixpanel: MixpanelService,
        private readonly route: ActivatedRoute,
    ) {
        super(injector);
    }

    error: string | null = null;
    isLoading: boolean = true;
    ssoPage: string | null = null;
    override ngOnInit(): void {
        // 1) Read "handle" from the route path and "code" from query params
        const handle = this.route.snapshot.paramMap.get('handle');
        const code = this.route.snapshot.queryParamMap.get('code');
        const state = this.route.snapshot.queryParamMap.get('state');
        this.ssoPage = state;
        if (!handle) {
            this.error = 'No SSO handle in URL.';
            this.isLoading = false;
            console.error(this.error);
            return;
        }
        if (!code) {
            this.error = 'No authorization code found in URL.';
            this.isLoading = false;
            console.error(this.error);
            return;
        }

        // 2) Delegate to AuthService to exchange code→customToken → signInWithCustomToken
        this.authService.handleSsoCallback$(handle, code, state).subscribe({
            next: () => {
                debug('Successfully signed in with custom token');
                this.isLoading = false;

                this.authProvider.dispatchGetCurrentUser();
            },
            error: (err) => {
                console.error('Error during SSO callback flow:', err);
                this.isLoading = false;
                this.error = 'Could not sign you in. Please try again.';
                // Optionally redirect back to /auth/login after a delay:
                // setTimeout(() => this.router.navigate(['/auth/login']), 3000);
            },
        });

        this.usersNavigationService.readyToRoute$
            .pipe(
                filter((readyToRoute) => {
                    return readyToRoute !== null && readyToRoute !== undefined;
                }),
                untilDestroyed(this),
            )
            .subscribe((lang) => this.routeToFsOverViewPage(lang));
    }

    private routeToFsOverViewPage(lang: string): void {
        this.router.navigate([`/${lang}/${Paths.HOME}`]);
    }

    backToSsoLoginPage() {
        // Navigate back to the SSO login page
        this.router.navigate(['..'], { relativeTo: this.activatedRoute });
    }
}
